import { createContext } from "react";

export default createContext();
//export let Forgotpasswordcontext=createContext({email:'',country_code:'',phone_number:''});